import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CustomPropTypes from "../utils/customPropTypes";
import Slider from "react-slick";
import SafeHTML from "../components/SafeHTML";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../../scss/components/ImageCardCarousel.scss';
export default class ImageCarousel extends React.Component {
    static propTypes = {
        header: PropTypes.string,
        title: PropTypes.string,
        content: PropTypes.string,
        cards: PropTypes.shape({
            image: CustomPropTypes.Image,
        })
    };
    render() {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            speed: 2000,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        return (
            <div className="container imgCarousal">
                <section className="rich-section">
                        <div className="rich-content">
                        {this.props.header &&
                            <h1 style={{textAlign:'center'}}>{this.props.header}</h1>
                        }
                        {this.props.title &&
                            <div style={{fontSize: '28px',textAlign:'center'}}>{this.props.title}</div>
                        }
                            <SafeHTML>{this.props.content}</SafeHTML>
                        </div>
                </section>
                <Slider {...settings}>
                    {
                        this.props.cards.map((objItem, index) => {
                            return (
                                <div>
                                    <img src={objItem.image.url} alt="Customer Story" class="trusted-img"></img>
                                </div>

                            )
                        }
                        )
                    }
                </Slider>
            </div>
        );
    }
}
